import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

@Component({
  selector: "page-horas",
  templateUrl: "horas.html",
})
export class HorasPage {
  pestanya = "extras";
  extras = [];
  compensacion = [];
  saldo;
  data = {
    background: "assets/images/background/39.jpg",
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private conector: ConectorProvider,
    private global: GlobalProvider
  ) {
    this.conector.getHoras().subscribe((data) => {
      console.log("horas", data);
      this.extras = data["horas_extra"];
      this.compensacion = data["horas_compensacion"];
      this.saldo = data["saldo"];
    });

    let TextLOG = "Acceso Lista de HORAS ";

    this.conector.registraractividad(TextLOG).subscribe((data) => {
      console.log("registramos Actividad", TextLOG);
    });
  }

  ionViewDidLoad() {}
}



// WEBPACK FOOTER //
// ./src/pages/horas/horas.ts